import { render, staticRenderFns } from "./AsignarFondeador.vue?vue&type=template&id=1b6209f0&scoped=true"
import script from "./AsignarFondeador.vue?vue&type=script&lang=js"
export * from "./AsignarFondeador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6209f0",
  null
  
)

export default component.exports